(() => {
  window.__HF_TABS__ = window.__HF_TABS__ || { listenersBound: false, lastPanel: {} };
  const state = window.__HF_TABS__;
  if (!state.lastPanel) state.lastPanel = {};

  function hoistMenuItems(root) {
    const menu = root.querySelector(':scope > .hf-tabs__menu-scroll .hf-tabs__menu');
    if (!menu) return;
    const panels = root.querySelectorAll(':scope > .hf-tabs__content > [data-hf-tab-panel]');
    const rootId = root.dataset.blockId || '';
    const tabStyle = root.dataset.tabStyle || 'paragraph';
    const radioName = `hf-tabs-${rootId}`;
    menu.innerHTML = '';
    panels.forEach((panel, index) => {
      const tpl = panel.querySelector(':scope > template[data-hf-tab-menu-template]');
      if (!tpl) return;
      const frag = tpl.content.cloneNode(true);
      const input = frag.querySelector('.hf-tabs__radio');
      const label = frag.querySelector('.hf-tabs__tab');
      if (input) {
        input.name = radioName;
        if (index === 0) input.checked = true;
      }
      if (label) label.classList.add(`hf-typo-preset--${tabStyle}`);
      menu.appendChild(frag);
    });
  }

  function initTabs(root) {
    if (!root || root.dataset.hfTabsInit === '1') return;
    root.dataset.hfTabsInit = '1';

    hoistMenuItems(root);

    const menu = root.querySelector(':scope > .hf-tabs__menu-scroll .hf-tabs__menu');
    const glider = root.querySelector(':scope > .hf-tabs__menu-scroll .hf-tabs__glider');
    const radios = root.querySelectorAll(':scope > .hf-tabs__menu-scroll .hf-tabs__radio');
    const panels = root.querySelectorAll(':scope > .hf-tabs__content > [data-hf-tab-panel]');

    if (!menu || !glider || radios.length === 0) return;

    const menuStyle = root.dataset.menuStyle || 'glider';

    function refreshPanelMedia(panel) {
      const slides = panel && panel.querySelectorAll('.hf-carousel');
      if (!slides || slides.length === 0) return;
      slides.forEach((el) => {
        if (typeof el._hfRefresh === 'function') {
          el._hfRefresh();
          return;
        }
        const car = el._hfCarousel;
        if (car && typeof car.reInit === 'function') car.reInit();
      });
      const sliders = panel.querySelectorAll('slider-component');
      sliders.forEach((sc) => {
        if (typeof sc.initPages === 'function') sc.initPages();
      });
    }

    function activatePanel(targetId) {
      let activated = null;
      panels.forEach((panel) => {
        const isActive = panel.dataset.hfTabPanel === targetId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) activated = panel;
      });
      if (activated) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => refreshPanelMedia(activated));
        });
      }
    }

    function updateGlider(label) {
      if (menuStyle !== 'glider') return;
      if (!label) return;
      const labelRect = label.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();
      const x = labelRect.left - menuRect.left;
      root.style.setProperty('--hf-tabs-glider-width', `${labelRect.width}px`);
      root.style.setProperty('--hf-tabs-glider-x', `${x}px`);
    }

    function getActiveLabel() {
      const checked = root.querySelector('.hf-tabs__radio:checked');
      if (!checked) return null;
      return root.querySelector(`label[for="${checked.id}"]`);
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        activatePanel(radio.dataset.hfTabTarget);
        state.lastPanel[root.dataset.blockId || ''] = radio.dataset.hfTabTarget;
        const label = root.querySelector(`label[for="${radio.id}"]`);
        requestAnimationFrame(() => updateGlider(label));
      });
    });

    let initialChecked = null;
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      const rememberedPanel = state.lastPanel[root.dataset.blockId || ''];
      if (rememberedPanel) {
        initialChecked = root.querySelector(`.hf-tabs__radio[data-hf-tab-target="${rememberedPanel}"]`);
      }
    }
    if (!initialChecked) {
      initialChecked = root.querySelector('.hf-tabs__radio:checked') || radios[0];
    } else {
      radios.forEach((r) => { r.checked = false; });
    }
    if (initialChecked) {
      if (!initialChecked.checked) initialChecked.checked = true;
      activatePanel(initialChecked.dataset.hfTabTarget);
    }

    requestAnimationFrame(() => updateGlider(getActiveLabel()));

    if (menuStyle === 'glider' && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => updateGlider(getActiveLabel()));
      ro.observe(menu);
    }
  }

  function initAll(scope) {
    const ctx = scope || document;
    ctx.querySelectorAll('[data-hf-tabs]').forEach(initTabs);
  }

  function deferInitAll(scope) {
    const run = () => initAll(scope);
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => deferInitAll());
  } else {
    deferInitAll();
  }

  if (!state.listenersBound) {
    document.addEventListener('shopify:section:load', (e) => deferInitAll(e.target));
    document.addEventListener('shopify:block:load', (e) => deferInitAll(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      activateTabFromBlock(e.target);
    });
    state.listenersBound = true;
  }

  function activateTabFromBlock(target) {
    if (!target || !target.closest) return;
    const panel = target.closest('[data-hf-tab-panel]');
    if (!panel) return;
    const root = panel.closest('[data-hf-tabs]');
    if (!root) return;
    const panelId = panel.dataset.hfTabPanel;
    state.lastPanel[root.dataset.blockId || ''] = panelId;
    const radio = root.querySelector(`.hf-tabs__radio[data-hf-tab-target="${panelId}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
})();
